/**
 * Cambio rapido della fase pipeline del Lead dal modale di completamento di una
 * Task commerciale (segnalazione cac9836a): logica pura, senza query.
 * Stessa forma di scrittura del drawer del Lead (`leadDrawerAdapter.commitEntityChanges`):
 * fase + ultima attivita', motivo della perdita valorizzato su fase persa, azzerato altrove.
 */

export const DEFAULT_LOST_REASONS = [
  'Budget insufficiente',
  'Scelto competitor',
  'Tempistiche non compatibili',
  'Non risponde',
  'Non in target',
  'Spam / Lead non valido',
  'Altro',
];

export interface QuickStage {
  id: string;
  name: string;
  is_lost?: boolean;
}

/** Il lead collegato a una task commerciale: `lead_id` o, per i clienti, `client_id`. */
export function resolveTaskLeadId(task: { lead_id?: string | null; client_id?: string | null } | null | undefined): string | null {
  return task?.lead_id || task?.client_id || null;
}

/** Errore da mostrare (o null) prima di salvare il cambio fase. */
export function validateLeadStageChange(stage: QuickStage | null | undefined, lostReason: string): string | null {
  if (stage?.is_lost && !lostReason.trim()) return 'Seleziona il motivo della perdita';
  return null;
}

/** Patch per `clients`, o null se la fase non cambia. */
export function buildLeadStageUpdate(params: {
  currentStageId: string | null;
  stage: QuickStage | null | undefined;
  lostReason: string;
  nowIso: string;
}): Record<string, string | null> | null {
  const { currentStageId, stage, lostReason, nowIso } = params;
  if (!stage || stage.id === currentStageId) return null;
  const patch: Record<string, string | null> = { pipeline_stage_id: stage.id, last_activity_date: nowIso };
  if (stage.is_lost) {
    patch.lost_reason = lostReason.trim();
    patch.lost_reason_date = nowIso;
  } else {
    patch.lost_reason = null;
    patch.lost_reason_date = null;
  }
  return patch;
}
